var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('t-logo-upload',{attrs:{"value":_vm.value,"disabled":_vm.readonly,"accept":"image/png,image/jpeg,image/jpg"},on:{"input":_vm.onInput}},[(_vm.fallback)?_c('img',{staticClass:"t-logo-upload__logo",attrs:{"src":_vm.fallback}}):_c('dashboard-image',{attrs:{"name":"upload"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }